<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead :title="'Room Availibility'"></cardHead>
      <load-area v-if="hotels == null"></load-area>
      <div class="row" v-if="hotels != null">
        <div class="left col-3 border-right p-r-0">
          <Form
            method="dialog"
            v-slot="{ errors }"
            class="floating-labels p-1rem border-bottom m-0"
            ref="form"
          >
            <formGroup
              :title="'StartDate'"
              v-model="model.StartDate"
              :errors="errors"
              :rules="{ required: true }"
              :max="model.EndDate"
              :disabled="process"
              type="date"
            ></formGroup>
            <formGroup
              :title="'EndDate'"
              v-model="model.EndDate"
              :errors="errors"
              :rules="{ required: true }"
              type="date"
              :min="model.StartDate"
              :disabled="process"
            ></formGroup>
            <Btn
              class="btn-primary tcenter w100"
              @click="
                data = {};
                get();
              "
              :process="process"
              :disabled="process || selectedHotel.length == 0"
              >Search</Btn
            >
          </Form>
          <input
            type="text"
            placeholder="Ara..."
            class="form-control p-10"
            v-model="search"
          />
          <ul class="list-group">
            <li
              class="list-group-item pointer"
              v-for="item in sortedHotels"
              :key="item.Id"
              :class="{ active: selectedHotel.indexOf(item.Id) > -1 }"
              v-show="
                item.Name.toUpperCase().indexOf(search.toUpperCase()) > -1
              "
              @click="setHotels(item)"
            >
              {{ item.Name }}
              <span
                v-if="item.RoomCount > 0"
                class="roomCount badge badge-light rounded-pill"
                >{{ item.RoomCount }}</span
              >
            </li>
          </ul>
        </div>
        <div class="right col-9 p-l-0">
          <div class="p-10" v-if="process">
            <div class="progress">
              <div
                class="progress-bar bg-success"
                :style="
                  'width: ' +
                    (100 / selectedHotel.length) * Object.keys(data).length +
                    '%;'
                "
                role="progressbar"
              >
                {{
                  (
                    (100 / selectedHotel.length) *
                    Object.keys(data).length
                  ).toFixed(0)
                }}%
              </div>
            </div>
          </div>
            <apexChart
            v-if="!process && Object.keys(data).length>0"
              :data="getAllDatasets"
            ></apexChart>
            <dataTable
              v-if="!process && Object.keys(data).length>0"
              :name="'RoomAvailibility'"
              ref="agGrid"
              :data="getData"
              :columnDefs="getColumns"
              @cellClicked="onCellClicked"
              @removeHotel="removeHotel"
            ></dataTable>
            <div class="emptyState tcenter" v-if="!process && Object.keys(data).length==0">
              <i class="fas fa-building"></i>
              <p>Soldan otel seçip <b>Search</b>'e basın.</p>
            </div>
        </div>
      </div>
    </div>
  </div>
  <detail v-if="detailShow!=null" @close="detailShow=null" :data="data[detailShow.Id]" :hotelName="detailShow.Name"></detail>
</template>

<script>
import apexChart from "../../../components/apexChart.vue";
import detail from "./detail.vue"
export default {
  name: "RoomAvailibility",
  components: { apexChart,detail },
  data() {
    return {
      search: "",
      hotels: null,
      selectedHotel: [],
      model: {
        StartDate: "2023-09-01",
        EndDate: "2023-09-30",
        HotelId: 5225,
      },
      data: {},
      process: false,
      detailShow:null
    };
  },
  created() {
    this.model.EndDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.model.StartDate = this.$moment(
      new Date().setDate(new Date().getDate() - 7)
    ).format("YYYY-MM-DD");
    this.$appAxiosAdmin.get(`CustomerHotels`).then((response) => {
      this.hotels = response.data;
    });
  },
  methods: {
    setHotels(item) {
      if (this.process) {
        return false;
      }
      this.selectedHotel.indexOf(item.Id) > -1
        ? (this.selectedHotel = this.selectedHotel.filter((x) => {
            return x != item.Id;
          }))
        : this.selectedHotel.push(item.Id);
    },
    removeHotel(item) {
      this.selectedHotel = this.selectedHotel.filter((x) => x != item.Id);
      delete this.data[item.Id];
      if (this.detailShow?.Id == item.Id) {
        this.detailShow = null;
      }
    },
    onCellClicked(e) {
      if (e.colDef?.type === "action") {
        return;
      }
      this.detailShow = e?.data;
    },
    get() {
      this.process = true;
      if (
        this.selectedHotel.filter((x) => {
          return Object.keys(this.data).indexOf(x.toString()) == -1;
        }).length == 0
      ) {
        this.process = false;
        return false;
      }
      this.model.HotelId = this.selectedHotel.filter((x) => {
        return Object.keys(this.data).indexOf(x.toString()) == -1;
      })[0];

      const softwareId = this.hotels.find((x) => {
        return x.Id == this.model.HotelId;
      })?.SoftwareId;
      const url =
        softwareId && [9, 12, 13, 15, 16].includes(softwareId)
          ? `pms/${softwareId}/Research/RoomAvailibility`
          : `Research/RoomAvailibility`;

      this.$appAxiosAdmin
        .post(url, this.model)
        .then((response) => {
          this.data[this.model.HotelId] = response.data;
          this.get();
        })
        .catch(() => {
          this.data[this.model.HotelId] = "Error";
          this.get();
        });
    },
  },
  computed:{
    sortedHotels() {
      return [...this.hotels].sort((a, b) => {
        const aSel = this.selectedHotel.indexOf(a.Id) > -1 ? 0 : 1;
        const bSel = this.selectedHotel.indexOf(b.Id) > -1 ? 0 : 1;
        return aSel - bSel;
      });
    },
    getAllDatasets() {
      var data = [];
      var percent = 0;
      let sumData = {};
      Object.entries(this.data).forEach((element) => {
        try {
          if (element[1] == "Error") {
            return false;
          }
          element[1].Rows.forEach((row) => {
            if (sumData[row.Date] == undefined) {
              sumData[row.Date] = {
                TotalEmpty: 0,
                TotalFilled: 0,
              };
            }
            sumData[row.Date].TotalEmpty += row.TotalEmpty;
            sumData[row.Date].TotalFilled += row.TotalFilled;
          });
        } catch (error) {
          console.log(error);
        }
      });
      Object.entries(sumData).forEach((element) => {
        percent = (element[1].TotalEmpty + element[1].TotalFilled) / 100;
        data.push({
          x: this.$moment(new Date(element[0])).format("DD.MM.YY"),
          y: element[1].TotalFilled,
          fillColor:
            element[1].TotalEmpty / percent < 6
              ? "#fc4b6c"
              : element[1].TotalEmpty / percent < 16
              ? "#ffb22b"
              : element[1].TotalEmpty / percent < 26
              ? "#ffef2b"
              : "#55ce63",
          goals: [
            {
              name: "Kapasite",
              value: element[1].TotalEmpty + element[1].TotalFilled,
              strokeColor: "#1e88e5",
            },
          ],
        });
      });
      return [
        {
          name: "Doluluk",
          data: data,
        },
      ];
    },
    getData() {
      let data = [];
      Object.entries(this.data).forEach((element) => {
        try {
          if (element[1] == "Error") {
            return false;
          }
          let hotel = {
            Name: this.hotels.filter((x) => {
              return x.Id == element[0];
            })[0].Name,
            Id:element[0]
          };
          element[1].Rows.forEach((row) => {
            hotel[this.$moment(new Date(row.Date)).format("DD/MM")] =
              row.TotalEmpty;
            hotel[this.$moment(new Date(row.Date)).format("DD/MM") + "F"] =
              row.TotalFilled;
          });
          data.push(hotel);
        } catch (error) {
          console.log(error);
        }
      });
      return data;
    },
    getColumns() {
      let columnDefs=[
        {
          headerName: "",
          type: "action",
          width: 40,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-danger",
              text: '<i class="far fa-times-circle"></i>',
              emit: "removeHotel",
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
        },
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: false,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        }
      ];
      try {
      this.data[Object.keys(this.data)[0]].Rows.forEach((row) => {
        columnDefs.push({
          headerName: this.$moment(new Date(row.Date)).format("DD/MM"),
          field: this.$moment(new Date(row.Date)).format("DD/MM"),
          enableRowGroup: false,
          floatingFilter: true,
          filter: "agNumberColumnFilter",
          width: 100,
          cellStyle: params => {
              let percent=(params.data[this.$moment(new Date(row.Date)).format("DD/MM") + "F"]+params.data[this.$moment(new Date(row.Date)).format("DD/MM")])/100;
              if (params.value / percent<6) {
                  return {color:"#fff", backgroundColor: '#fc4b6c'};
              }
              else if (params.value / percent<16) {
                  //mark police cells as red
                  return {color:"#fff", backgroundColor: '#ffb22b'};
              }
              else if (params.value / percent<26) {
                  //mark police cells as red
                  return {backgroundColor: '#ffef2b'};
              } else if(percent>0) {
              return { color: "#fff", backgroundColor: "#55ce63" };
            }
          }
        });
      });
      } catch (error) {
        console.log(error);
      }
      return columnDefs;
    },
  }
};
</script>
<style scoped>
.left {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 220px);
}
.left input {
  border-radius: 0;
  border-width: 0 0 1px 0;
  flex-shrink: 0;
}
.left .btn-primary:disabled {
  background: #ccc !important;
  border-color: #ccc !important;
  box-shadow: none !important;
  opacity: 0.75;
  cursor: not-allowed;
}
.left ul {
  border: none;
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: auto;
  margin-bottom: 0;
}
.left ul li {
  padding: 5px 10px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 0;
  white-space: nowrap;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.left ul li:not(.active):hover {
  background-color: #f8f9fa;
}
.left ul li .roomCount {
  background-color: rgba(0, 0, 0, 0.09);
  color: #495057;
  font-size: 12px;
  font-weight: 600;
  margin-left: 6px;
}
.left ul li.active .roomCount {
  background-color: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}
.right .emptyState {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: rgb(160, 160, 160);
  padding: 60px 10px;
}
.right .emptyState i {
  font-size: 42px;
  margin-bottom: 14px;
  opacity: 0.6;
}
.right .emptyState p {
  margin: 0;
  font-size: 14px;
}
</style>
